// @ts-nocheck
import React, { PureComponent } from 'react'
import { capitalize, cloneDeep, find } from 'lodash'
import { Tag } from '../../generic'

type PropertyFilterTagsProps = {
  activeFilters: { [key: string]: string[] }
  allFilters: { [key: string]: { filters: Filter[] } }
  onChange: (filter: { key: string; value: string }) => void
  style: React.CSSProperties
  testId?: string
}

type Filter = {
  value: string
  badgeColor?: string
  badgeText?: string
  icon?: string
  iconColor?: string
  picture?: string
  label?: string
}

export default class PropertyFilterTags extends PureComponent<PropertyFilterTagsProps> {
  getActiveFilterData = () => {
    const { allFilters, activeFilters } = this.props
    const activeFilterData = cloneDeep(activeFilters)
    if (!allFilters) return activeFilterData

    for (const key in activeFilterData) {
      const active = activeFilterData[key]
      const all = allFilters[key]
      if (!active || !active.length || !all) {
        continue
      }
      activeFilterData[key] = active
        .map((value) => find(all.filters, { value }))
        .filter((d) => d)
    }

    return activeFilterData
  }

  render() {
    const { onChange, style, testId } = this.props
    const activeFilterData = this.getActiveFilterData()
    if (!activeFilterData) return null
    return (
      <div
        style={{
          ...style,
          ...styles.wrapper,
        }}
        data-testid={testId ? `${testId}-filter-tags` : undefined}
      >
        {Object.keys(activeFilterData).map((key) => {
          if (!key) return null

          const filters = activeFilterData[key]
          if (!filters || !filters.length) return null

          return filters.map((filter, index) => {
            const tagTestId = testId
              ? `${testId}-filter-tag-${index}`
              : undefined
            return (
              <Tag
                badgeColor={filter.badgeColor}
                badgeText={filter.badgeText}
                icon={filter.icon}
                iconColor={filter.iconColor}
                key={filter.value}
                onClick={() => onChange({ key, value: filter.value })}
                picture={filter.picture}
                label={filter.label || capitalize(filter.value)}
                data-testid={tagTestId}
              />
            )
          })
        })}
      </div>
    )
  }
}

const styles = {
  wrapper: {
    display: 'flex',
    flexWrap: 'wrap',
  },
}
